import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { PopoverModule } from 'ngx-bootstrap/popover';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { DateAngularModule } from 'rev-shared/date/DateAngular.Module';
import { DialogRegistrationService } from 'rev-shared/ui/dialog/DialogRegistration.Service';
import { SelectAngularModule } from 'rev-shared/ui/select/SelectAngular.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { VbTextAreaModule } from 'rev-shared/ui/textArea/VbTextArea.Module';

import { ApprovalApproveComponent } from './ApprovalApprove.Component';
import { ApprovalDialogComponent } from './ApprovalDialog.Component';
import { ApprovalProcessContainerComponent } from './ApprovalProcessContainer.Component';
import { ApprovalRequestComponent } from './ApprovalRequest.Component';
import { ApprovalSubmitBtnComponent } from './ApprovalSubmitBtn.Component';
import { ApprovalSubmittedDetailsComponent } from './ApprovalSubmittedDetails.Component';

const declarations = [
	ApprovalApproveComponent,
	ApprovalDialogComponent,
	ApprovalProcessContainerComponent,
	ApprovalRequestComponent,
	ApprovalSubmitBtnComponent,
	ApprovalSubmittedDetailsComponent
];

@NgModule({
	declarations,
	imports: [
		ButtonsAngularModule,
		CommonModule,
		DateAngularModule,
		FormsModule,
		PopoverModule,
		SelectAngularModule,
		SpinnerAngularModule,
		TranslateModule,
		VbTextAreaModule
	],
	exports: declarations
})

export class VideoApprovalProcessModule {
	constructor(dialog: DialogRegistrationService) {
		dialog.register('ApprovalDialog', { component: ApprovalDialogComponent });
	}
}
